import React from "react";
import C3Chart from "react-c3js";
import clientService from "../../../services/client";
import ChartDateRangeForm from "./ChartDateRangeForm";
import AnalyticsChartCard from "./AnalyticsChartCard";
import { defaultStartDate, barAxis } from "./chartUtils";

const emptyChart = {
  bindto: "#service-breakdown",
  x: "x",
  columns: [["x"], ["Total Users"], ["Total Unique Users"]],
  type: "bar",
};

export default class ServiceBreakdownChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: defaultStartDate(),
      endDate: new Date(),
      filterStartDate: defaultStartDate().toLocaleDateString("en-US"),
      filterEndDate: new Date().toLocaleDateString("en-US"),
      chartData: emptyChart,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  async fetchData() {
    const { filterStartDate, filterEndDate } = this.state;
    try {
      const uniqueRes = await clientService.getChartUserData(
        filterStartDate,
        filterEndDate,
        true,
      );
      const allRes = await clientService.getChartUserData(
        filterStartDate,
        filterEndDate,
        false,
      );
      const uniqueData = uniqueRes.data || [];
      const allData = allRes.data || [];
      const xAxis = uniqueData.map((a) => a.contextName);
      const uniqueCounts = uniqueData.map((a) => a.count);
      const allCounts = allData.map((a) => a.count);

      this.setState({
        chartData: xAxis.length
          ? {
              bindto: "#service-breakdown",
              x: "x",
              columns: [
                ["x", ...xAxis],
                ["Total Users", ...allCounts],
                ["Total Unique Users", ...uniqueCounts],
              ],
              type: "bar",
              colors: {
                "Total Users": "#662C8F",
                "Total Unique Users": "#EC4697",
              },
            }
          : emptyChart,
      });
    } catch (err) {
      console.error(err);
    }
  }

  handleDateChange = (type, date) => {
    const changeDate = new Date(date).toLocaleDateString("en-US");
    if (type === "startDate") {
      this.setState({ startDate: date, filterStartDate: changeDate });
    } else {
      this.setState({ endDate: date, filterEndDate: changeDate });
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.fetchData();
  };

  render() {
    return (
      <React.Fragment>
        <ChartDateRangeForm
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          onStartChange={(date) => this.handleDateChange("startDate", date)}
          onEndChange={(date) => this.handleDateChange("endDate", date)}
          onSubmit={this.handleSubmit}
          layout="wide"
        />
        <AnalyticsChartCard title="Service Breakdown">
          <C3Chart
            data={this.state.chartData}
            size={{ height: 440 }}
            bar={{ width: 50 }}
            axis={barAxis}
            padding={{ bottom: 0, top: 0 }}
          />
        </AnalyticsChartCard>
      </React.Fragment>
    );
  }
}
